import { FC } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import cn from 'classnames';
import { usePlausible } from 'next-plausible';
import styles from './ProjectCard.module.css';
import type { Project } from '@lib/types/project';
import { urlFor } from '@lib/sanity';

interface Props {
  className?: string;
  project: Project;
  noNameTag?: boolean;
}

const ProjectCard: FC<Props> = ({ project, className, noNameTag }) => {
  const plausible = usePlausible();
  const rootClassName = cn(styles.root, styles.simple, className);

  return (
    <Link
      href={`/projects/${project.slug}`}
      prefetch={false}
      className={rootClassName}
      onClick={() =>
        plausible('projectCard', { props: { name: project.name } })
      }
    >
      <span className="sr-only">{project.name}</span>
      <>
        {!noNameTag && (
          <div className={styles.header}>
            <h3 className={styles.name}>
              <span>{project.name}</span>
            </h3>
          </div>
        )}
        {project?.images && (
          <Image
            alt={project.name}
            className={styles.productImage}
            src={urlFor(project.images[0]).width(540).height(540).url()}
            height={540}
            width={540}
            quality="85"
          />
        )}
      </>
    </Link>
  );
};

export default ProjectCard;
